import type { BatchStatus, MovementKind, QualityStatus } from "@/features/inventory/types";

export const BATCH_STATUSES: { value: BatchStatus; label: string }[] = [
  { value: "in_stock", label: "In stock" },
  { value: "reserved", label: "Reserved" },
  { value: "consumed", label: "Consumed" },
  { value: "dispatched", label: "Dispatched" },
];

export const QUALITY_STATUSES: { value: QualityStatus; label: string }[] = [
  { value: "pending", label: "Pending" },
  { value: "passed", label: "Passed" },
  { value: "hold", label: "Hold" },
  { value: "rejected", label: "Rejected" },
];

export const MOVEMENT_KINDS: { value: MovementKind; label: string }[] = [
  { value: "receipt", label: "Receipt" },
  { value: "issue", label: "Issue" },
  { value: "transfer", label: "Transfer" },
  { value: "adjustment", label: "Adjustment" },
  { value: "reserve", label: "Reserve" },
  { value: "unreserve", label: "Unreserve" },
];

export function labelFor(
  options: { value: string; label: string }[],
  value: string | null | undefined,
) {
  if (!value) return "—";
  return options.find((o) => o.value === value)?.label ?? value;
}

export function batchStatusTone(
  status: BatchStatus,
): "success" | "warning" | "danger" | "neutral" {
  switch (status) {
    case "in_stock":
      return "success";
    case "reserved":
      return "warning";
    case "consumed":
    case "dispatched":
      return "neutral";
    default:
      return "neutral";
  }
}

export function qualityTone(
  status: QualityStatus,
): "success" | "warning" | "danger" | "neutral" {
  switch (status) {
    case "passed":
      return "success";
    case "pending":
      return "warning";
    case "hold":
    case "rejected":
      return "danger";
    default:
      return "neutral";
  }
}

export function money(value: unknown) {
  const n = typeof value === "number" ? value : Number(value ?? 0);
  return Number.isNaN(n) ? 0 : n;
}

export function fmtQty(n: number | null | undefined) {
  if (n == null || Number.isNaN(n)) return "—";
  return Number.isInteger(n) ? String(n) : n.toFixed(3).replace(/\.?0+$/, "");
}
